<template>
  <div class="expertDetail">
    <div class="title_box">
      <h4>期刊详情</h4>
      <el-button
        size="small"
        type="info"
        @click="backProject"
      >返回</el-button>
    </div>
    <el-card>
      <div class="introduce">
        <div style="display: flex; align-items: center;">
          <div class="header">
            <!-- <el-image v-if="aprenderObj.logo=='' "></el-image> -->
            <el-image v-if="aprenderObj.logo=='' ">
              <div
                class="r_sbox-img-slot"
                slot="error"
              >暂无</div>
            </el-image>
            <img
              v-else
              :src="aprenderObj.logo"
            >
          </div>
        </div>
        <div class="line"></div>
        <div class="discribtion">
          <h5>{{aprenderObj.name}}</h5>
          <p class="hospital">
            <span>期刊级别:{{aprenderObj.level_text}} </span>
          </p>
          <p class="text">
            <span>
              联系人：
              <span
                v-if="aprenderObj.user_name">{{aprenderObj.user_name}}</span>
              <span v-else>暂无</span>
            </span>
            &nbsp;&nbsp;&nbsp;
            <span>
              联系方式:
              <span
                v-if="aprenderObj.user_phone">{{aprenderObj.user_phone}}</span>
              <span v-else>暂无</span>
            </span>
          </p>
          <p
            class="phons"
            v-if="aprenderObj.email"
          >
            <i class="iconfont icon-24gl-mailboxFull"></i>
            {{aprenderObj.email}}
          </p>
        </div>
      </div>
    </el-card>
    <div class="b_box">
      <div class="l_box">
        <ul class="l_sbox">
          <li>
            <h4>CN</h4>
            <el-tooltip
              class="item"
              effect="dark"
              :content="aprenderObj.cn"
              placement="top"
            >
              <p v-if="aprenderObj.cn!='' ">{{aprenderObj.cn}}</p>
              <span
                v-else
                class="kong"
              >暂无数据</span>
            </el-tooltip>
          </li>
          <li>
            <h4>机构公众号</h4>
            <el-tooltip
              class="item"
              effect="dark"
              :content="aprenderObj.account"
              placement="top"
            >
              <p v-if="aprenderObj.account!='' ">
                {{aprenderObj.account}}</p>
              <span
                v-else
                class="kong"
              >暂无数据</span>
            </el-tooltip>
          </li>
          <li>
            <h4>官方网址</h4>
            <el-tooltip
              class="item"
              effect="dark"
              :content="aprenderObj.website"
              placement="top"
            >
              <p v-if="aprenderObj.website!=''">{{aprenderObj.website}}</p>
              <span
                v-else
                class="kong"
              >暂无数据</span>
            </el-tooltip>
          </li>
          <li>
            <h4>办公地址</h4>
            <el-tooltip
              class="item"
              effect="dark"
              :content="aprenderObj.address"
              placement="top"
            >
              <p v-if="aprenderObj.address!='' ">{{aprenderObj.address}}</p>
              <span
                v-else
                class="kong"
              >暂无数据</span>
            </el-tooltip>
          </li>
        </ul>
        <ul class="r_sbox">
          <li>
            <h5>期刊介绍</h5>
            <span
              v-if="aprenderObj.desc=='' "
              class="kong"
            >暂无数据</span>
            <el-tooltip
              class="item"
              effect="dark"
              :content="aprenderObj.desc"
              placement="top"
            >
              <p>{{aprenderObj.desc}}</p>
            </el-tooltip>
          </li>
          <li>
            <h5>二维码</h5>
            <div class="r_sbox-img">
              <!-- <el-image v-if="aprenderObj.qrcode=='' "></el-image> -->
              <el-image v-if="aprenderObj.qrcode=='' ">
                <div
                  class="r_sbox-img-slot"
                  slot="error"
                >暂无</div>
              </el-image>
              <img
                :src="aprenderObj.qrcode"
                v-else
              >
            </div>
          </li>
          <li>
            <h5>附件</h5>
            <p
              class="annexes"
              @click="AnnexesClick(aprenderObj.enclosure)"
              v-if="aprenderObj.enclosure"
            >{{aprenderObj.enclosure}}</p>
            <span
              v-if="aprenderObj.enclosure=='' "
              class="kong"
            >暂无数据</span>
          </li>
        </ul>
      </div>
      <div class="r_box">
        <h4>备注</h4>
        <span
          v-if="aprenderObj.remarks=='' "
          class="kong"
        >暂无数据</span>
        <el-tooltip
          class="item"
          effect="dark"
          :content="aprenderObj.remarks"
          placement="top"
        >
          <p> {{aprenderObj.remarks}} </p>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'expertDetail',
  data () {
    return {
      aprenderObj: {}
    }
  },
  created () {
    this.getAprender(this.$route.query.id, 'periodical')
  },
  methods: {
    async getAprender (id, type) {
      const { data: data } = await this.$http.post("info/detail", {
        type,
        id
      })
      this.aprenderObj = data.data
    },

    AnnexesClick (url) {
      window.open(url);
    },
    //返回
    backProject () {
      this.$router.back()
    }
  }
}
</script>

<style lang='less' scoped>
.expertDetail {
  width: 100%;
  height: 100%;
  // overflow-y: auto;
  .title_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;
    h4 {
      font-size: 28px;
      color: #212529;
    }
  }
  .title {
    color: #212529;
    font-size: 28px;
    padding-bottom: 11px;
    border-bottom: 1px solid #e8e8e8;
  }
  .el-card {
    margin-top: 20px;
    .introduce {
      width: 100%;
      display: flex;
      .header {
        width: 130px;
        height: 130px;
        border-radius: 50%;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
        /deep/ .el-image {
          width: 100% !important;
          height: 100% !important;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #f5f7fa;
          .r_sbox-img-slot {
            font-size: 14px;
            color: #c0c4cc;
            vertical-align: middle;
          }
        }
      }
      .names {
        color: #9a9b9d;
        font-size: 16px;
        text-align: center;
        margin-top: 10px;
      }
    }
    .line {
      min-height: 173px;
      background: #e4e4e4;
      width: 1px;
      margin-left: 26px;
    }
    .discribtion {
      flex: 1;
      margin-left: 21px;
      h5 {
        font-size: 16px;
        color: #212529;
      }
      .hospital {
        margin-top: 8px;
        span {
          margin-right: 26px;
          color: #9a9b9d;
          font-size: 12px;
        }
      }
      .text {
        margin-top: 20px;
        color: #212529;
        font-size: 13px;
        // line-height: 24px;
        // height: 48px;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // display: -webkit-box;
        // -webkit-line-clamp: 2;
      }
      .phons {
        margin-top: 34px;
        color: #212529;
        font-size: 13px;
      }
    }
  }
  .b_box {
    // flex: 1;
    width: 100%;
    // height: 510px;
    margin-top: 20px;
    display: flex;
    .l_box {
      flex: 1;
      height: 100%;
      background: #fff;
      border: 1px solid #f0f0f0;
      display: flex;
      justify-content: space-between;
      padding: 32px;
      .l_sbox {
        width: 50%;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        li {
          margin-bottom: 20px;
          border: 1px solid #f0f0f0;
          border-radius: 8px;
          padding: 25px;
          h4 {
            color: #212529;
            font-size: 16px;
          }
          p {
            cursor: pointer;
            font-size: 13px;
            color: #212529;
            margin-top: 10px;
            line-height: 24px;
            overflow: hidden; //超出隐藏
            text-overflow: ellipsis; //超出文本设置为...
            display: -webkit-box; //将div1转换为盒子模型
            -webkit-line-clamp: 2; //设置div1的文本为2行
            -webkit-box-orient: vertical; //从顶部向底部垂直布置子元素
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      .r_sbox {
        // height: 100%;
        flex: 1;
        justify-content: center;
        align-items: center;
        border: 1px solid #f0f0f0;
        margin-left: 27px;
        padding: 25px;
        li {
          // margin-bottom: 41px;
          // margin-bottom: 100px;
          &:nth-child(2) {
            margin-top: 80px;
          }
          &:nth-child(3) {
            margin-top: 40px;
          }
        }
        h5 {
          font-size: 16px;
          color: #212529;
          margin-bottom: 30px;
        }
        .r_sbox-img {
          width: 110px;
          height: 110px;
          img {
            width: 100%;
            height: 100%;
          }
          /deep/ .el-image {
            width: 100% !important;
            height: 100% !important;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #f5f7fa;
            .r_sbox-img-slot {
              font-size: 14px;
              color: #c0c4cc;
              vertical-align: middle;
            }
          }
        }
        p {
          font-size: 13px;
          color: #212529;
          cursor: pointer;
          transition: all 0.5s;
          margin-bottom: 40px;
          overflow: hidden; //超出隐藏
          text-overflow: ellipsis; //超出文本设置为...
          display: -webkit-box; //将div1转换为盒子模型
          -webkit-line-clamp: 2; //设置div1的文本为2行
          -webkit-box-orient: vertical; //从顶部向底部垂直布置子元素
          // &:hover {
          //   color: #6167aa;
          //   font-weight: bold;
          // }
        }
      }
    }
    .r_box {
      width: 417px;
      // height: 100%;
      border: 1px solid #f0f0f0;
      border-radius: 8px;
      background: #fff;
      margin-left: 20px;
      padding: 25px 28px;
      h4 {
        color: #212529;
        font-size: 16px;
      }
      p {
        font-size: 13px;
        color: #212529;
        margin-top: 10px;
        line-height: 24px;
        cursor: pointer;
        overflow: hidden; //超出隐藏
        text-overflow: ellipsis; //超出文本设置为...
        display: -webkit-box; //将div1转换为盒子模型
        -webkit-line-clamp: 20; //设置div1的文本为2行
        -webkit-box-orient: vertical; //从顶部向底部垂直布置子元素
      }
    }
  }
  .kong {
    display: flex;
    margin-top: 10px;
  }

  .annexes {
    &:hover {
      color: #6167aa;
      font-weight: bold;
    }
  }
}
</style>